import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const Footer: React.FC = () => {
  const { t } = useTranslation('common');
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h4>{t('app_name')}</h4>
          <p>{t('footer.tagline')}</p>
        </div>

        <div className="footer-section">
          <h4>{t('footer.links_title')}</h4>
          <ul className="footer-links">
            <li><Link to="/">{t('footer.link_home')}</Link></li>
            <li><Link to="/reports">{t('footer.link_reports')}</Link></li>
            <li><Link to="/profile">{t('footer.link_profile')}</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>{t('footer.legal_title')}</h4>
          <ul className="footer-links">
            <li><Link to="/terms">{t('footer.link_terms')}</Link></li>
            <li><Link to="/privacy">{t('footer.link_privacy')}</Link></li>
            <li><Link to="/contact">{t('footer.link_contact')}</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>{t('footer.copyright', { year: currentYear })}</p>
        <p style={{ fontSize: '0.75rem', marginTop: '4px', opacity: 0.7 }}>
          IP geolocation by <a href="https://db-ip.com" target="_blank" rel="noopener noreferrer">DB-IP</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
